export const schemesCategoriesSubMenu = [{
  path: '/schemes-categories/list/',
  component: () => import('@/views/schemes-categories/list.vue'),
  name: 'productManagement.schemesCategories.title',
  meta: {
    title: 'productManagement.schemesCategories.title',
    roles: ['Super Admin', 'Admin'],
    noCache: true,
    icon: 'tree'
  }
}, {
  path: '/schemes-categories/edit/:id(\\d+)',
  component: () => import('@/views/schemes-categories/manage.vue'),
  name: 'productManagement.schemesCategories.manage',
  props: {
    isEdit: true
  },
  meta: {
    title: 'productManagement.schemesCategories.manage',
    noCache: true,
    activeMenu: '/schemes-categories/list',
    hidden: true
  }
}, {
  path: '/schemes-categories/add',
  component: () => import('@/views/schemes-categories/manage.vue'),
  name: 'productManagement.schemesCategories.manage',
  props: {
    isEdit: false
  },
  meta: {
    title: 'productManagement.schemesCategories.manage',
    noCache: true,
    activeMenu: '/schemes-categories/list',
    hidden: true
  }
}];